
import {
  defineComponent,
  computed,
  // ref,
  // watch,
  // onBeforeUnmount,
  // onMounted,
} from "vue";
import MainPageHeader from "./components/Header.vue";
import MainPageFooter from "./components/Footer.vue";
import MarketplaceHeader from "./components/MarketplaceHeader.vue";
import SmallFooter from "./components/SmallFooter.vue";
// import RegistrationWarningModal from "@/components/Modals/RegistrationWarningModal.vue";

import { useRoute } from "vue-router";
// import { useStore } from "vuex";

export default defineComponent({
  name: "App",
  components: {
    MainPageHeader,
    MainPageFooter,
    MarketplaceHeader,
    // RegistrationWarningModal,
  },
  setup() {
    const route = useRoute();
    // const store = useStore();

    // const registrationWarningModal = ref<any>(null);

    // const isLoggedIn = computed(() => store.state.auth.status.loggedIn);

    // const BLOCKED_ROUTES = ["AuthPage", "ResetPassword"];

    // const STORAGE_KEY = "registration_warning_shown";

    // const isAuthModalOpen = ref(false);
    // let authModalEl: HTMLElement | null = null;

    // let timer: number | null = null;

    // const isAuthRoute = () => BLOCKED_ROUTES.includes(route.name as string);

    // const alreadyShown = () => {
    //   try {
    //     return sessionStorage.getItem(STORAGE_KEY) === "1";
    //   } catch {
    //     return false;
    //   }
    // };

    // const markShown = () => {
    //   try {
    //     sessionStorage.setItem(STORAGE_KEY, "1");
    //   } catch {
    //     // ignore
    //   }
    // };

    // const onAuthModalShown = () => {
    //   isAuthModalOpen.value = true;
    //   clearTimer();
    // };

    // const onAuthModalHidden = () => {
    //   isAuthModalOpen.value = false;
    //   startTimerIfNeeded();
    // };

    const currentHeaderComponent = computed(() => {
      const marketplaceRoutes = ["Marketplace", "MarketplaceItem"];

      if (marketplaceRoutes.includes(route.name as string)) {
        return MarketplaceHeader;
      }
      return MainPageHeader;
    });

    const currentFooterComponent = computed(() => {
      const marketplaceRoutes = ["AuthPage"];

      if (!marketplaceRoutes.includes(route.name as string)) {
        return SmallFooter;
      }
      return "";
    });

    // const clearTimer = () => {
    //   if (timer !== null) {
    //     clearTimeout(timer);
    //     timer = null;
    //   }
    // };

    // const startTimerIfNeeded = () => {
    //   clearTimer();
    //   if (isLoggedIn.value) return;

    //   if (isAuthRoute()) return;

    //   if (isAuthModalOpen.value) return;

    //   if (alreadyShown()) return;

    //   timer = window.setTimeout(() => {
    //     if (
    //       !isLoggedIn.value &&
    //       !alreadyShown() &&
    //       !isAuthRoute() &&
    //       !isAuthModalOpen.value
    //     ) {
    //       registrationWarningModal.value?.openModal?.();
    //       markShown();
    //     }
    //   }, 10_000);
    // };

    // onMounted(() => {
    //   authModalEl = document.getElementById("authModal");

    //   if (authModalEl) {
    //     authModalEl.addEventListener("shown.bs.modal", onAuthModalShown);
    //     authModalEl.addEventListener("hidden.bs.modal", onAuthModalHidden);

    //     isAuthModalOpen.value = authModalEl.classList.contains("show");
    //   }

    //   startTimerIfNeeded();
    // });

    // watch(isLoggedIn, () => startTimerIfNeeded());

    // watch(
    //   () => route.name,
    //   () => startTimerIfNeeded()
    // );

    // onBeforeUnmount(() => {
    //   clearTimer();

    //   if (authModalEl) {
    //     authModalEl.removeEventListener("shown.bs.modal", onAuthModalShown);
    //     authModalEl.removeEventListener("hidden.bs.modal", onAuthModalHidden);
    //   }
    // });

    return {
      currentHeaderComponent,
      currentFooterComponent,
      // registrationWarningModal,
    };
  },
});
